import { useHistory } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { pathOr, pipe, propEq, isEmpty } from 'ramda'
import { select } from '@/store'
import { useDispatch, useSelector } from '@/hooks/redux'
import useCurrentSession from '@/hooks/use-current-session'
import config from '@/config'

const CustomContractView = ({
  match: {
    params: { supportDocId, contractId }
  }
}) => {
  const history = useHistory()
  const session = useCurrentSession()
  const dispatch = useDispatch()
  const isExternal = !!session?.signer

  const { packageFiles = [] } = useSelector(state =>
    select.contract.contractPackageInfo(state, { contractId })
  )
  const [isLoading, setIsLoading] = useState(true)
  const isStateEmpty = isEmpty(packageFiles)
  const packageFile = isExternal
    ? pipe(pathOr({}, ['package_files', supportDocId]))(session)
    : pathOr({}, [supportDocId], packageFiles)

  dispatch.loading.setLoading()

  useEffect(() => {
    async function fetchData() {
      await dispatch.contract.getPackage({ contractId: contractId })
      setIsLoading(false)
    }

    if (isStateEmpty && !isExternal) fetchData()
  }, [contractId, dispatch.contract, isStateEmpty, isExternal])

  const fileId = packageFile?.id
  const isComplete = pipe(propEq('is_fully_signed', true))(packageFile)

  const logoutAndRedirect = useCallback(async () => {
    await dispatch.auth.logout()
    history.replace('/')
  }, [history, dispatch])

  const stopLoading = useCallback(async () => {
    await dispatch.loading.stopLoading()
  }, [history, dispatch])

  useEffect(() => {
    if (!isExternal && isLoading) return
    if (isComplete && fileId) {
      stopLoading()
      window.open(
        `${config.BACKEND_SERVER}/contracts/${contractId}/render/package/${fileId}`,
        '_self'
      )
    } else {
      stopLoading()
      logoutAndRedirect()
    }
  }, [fileId, isComplete, logoutAndRedirect, contractId, isExternal, isLoading])

  return null
}

export default CustomContractView
